import React from "react";
import styled, { keyframes } from "styled-components";

import theme from "../../styles/theme";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Container = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
`;

const Row = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 10px;
  border-radius: 4px;
`;

const Base = styled.div`
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.06) 0%,
    rgba(255, 255, 255, 0.12) 50%,
    rgba(255, 255, 255, 0.06) 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

const Avatar = styled(Base)`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid ${theme.colors.grey};
`;

const Name = styled(Base)`
  width: 120px;
  height: 14px;
  border-radius: 6px;
`;

const Chevron = styled(Base)`
  width: 12px;
  height: 12px;
  border-radius: 3px;
  opacity: 0.8;
`;

const UserMenuSkeleton = () => {
  return (
    <Container>
      <Row>
        <Avatar />
        <Name />
        <Chevron />
      </Row>
    </Container>
  );
};

export default UserMenuSkeleton;

